import Swiper from 'swiper'
import { Pagination, Autoplay } from 'swiper/modules'

export default class PictoList {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    new Swiper(this.el.querySelector('.picto-list--swiper'), {
      modules: [Pagination, Autoplay],
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      slidesPerView: 2,
      loop: true,
      speed: 600,
      pagination: {
        el: this.el.querySelector('.picto-list--pagination'),
        clickable: true,
      },
      breakpoints: {
        992: {
          enabled: false,
        },
      },
    })
  }
}
